import React, { useState } from 'react';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';

import ChatModal from '../Layout/Chat/ChatModal';
import Headline from '../ui/Typography/Headline';
import Paragraph from '../ui/Typography/Paragraph';
import Button from '../ui/Controls/Button';
import { useAppDispatch } from '../../store/hooks';
import { setActiveModal } from '../../store/slices/modals';
import { closeChat } from '../../store/actions/chat';
import setQaAttribute from '../../helpers/setQaAttribute';
import { CHAT_MODAL_CANCEL, CHAT_MODAL_CLOSE_CONFIRM } from '../../constants/qaAttributes';

const CloseChat = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const closeModal = () => {
    dispatch(setActiveModal(''));
  };

  const closeChatAction = async () => {
    try {
      setLoading(true);
      await dispatch(closeChat());
      closeModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ChatModal offsetClick={closeChat}>
      <Headline type="secondary" lineHeight="32" fontSize="20" className="indent-xs-bottom">
        End this chat
      </Headline>
      <Paragraph className="indent-xl-bottom">Are you sure you want to end this chat?</Paragraph>
      <Actions width="full" gap="8" direction="column">
        <ActionsItem width="full">
          <Button
            text="Stop chat"
            onClick={closeChatAction}
            {...setQaAttribute(CHAT_MODAL_CLOSE_CONFIRM)}
          />
        </ActionsItem>
        <ActionsItem width="full">
          <Button
            variant="primary-text"
            text="Cancel"
            onClick={closeModal}
            disabled={loading}
            {...setQaAttribute(CHAT_MODAL_CANCEL)}
          />
        </ActionsItem>
      </Actions>
    </ChatModal>
  );
};

export default CloseChat;
